import * as c from '../constants/unity';

export const setMode = (mode) => ({
  type: c.UNITY_SET_MODE,
  mode,
});

export const setScene = (scene) => ({
  type: c.UNITY_SET_SCENE,
  scene,
});

export const addUnityCommand = (command) => ({
  type: c.UNITY_ADD_COMMAND,
  command,
});

export const setVisible = (visible = true) => ({
  type: c.UNITY_SET_VISIBLE,
  visible,
});

export const setLoading = (loading = true) => ({
  type: c.UNITY_SET_LOADING,
  loading,
});

export const setLoadingProgress = (progress, message = '') => ({
  type: c.UNITY_SET_LOADING_PROGRESS,
  progress,
  message,
});

export const setInitialized = (error = undefined) => ({
  type: c.UNITY_SET_INITIALIZED,
  error,
});
